export default __webpack_public_path__ + "static/media/exito_small.6cd28115.svg";